var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioOffButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fill: "#042b62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,469.3c-117.8,0-213.3-95.5-213.3-213.3S138.2,42.7,256,42.7S469.3,138.2,469.3,256S373.8,469.3,256,469.3z M256,426.7 c45.3,0,88.7-18,120.7-50c32-32,50-75.4,50-120.7c0-45.3-18-88.7-50-120.7c-32-32-75.4-50-120.7-50c-45.3,0-88.7,18-120.7,50 c-32,32-50,75.4-50,120.7c0,45.3,18,88.7,50,120.7C167.3,408.7,210.7,426.7,256,426.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOffButton);
export default __webpack_public_path__ + "static/media/radio-off-button.62382f2eb75b08426eb828c908ac48b8.svg";
export { ForwardRef as ReactComponent };